var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhysicianGroupIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "21px",
    viewBox: "0 0 19.0 21.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1920,0 L1920,1030 L0,1030 L0,0 L1920,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.2,0 C11.4,0 13.2,1.8 13.2,4 L13.2,4.1 L16.5,4.1 C16.8,4.1 17.1,4.4 17.1,4.7 L17.1,19.2 L17.7,19.2 C18,19.2 18.3,19.5 18.3,19.8 C18.3,20.1 18,20.4 17.7,20.4 L0.6,20.4 C0.3,20.4 0,20.1 0,19.8 C0,19.5 0.3,19.2 0.6,19.2 L1.2,19.2 L1.2,4.7 C1.2,4.4 1.5,4.1 1.8,4.1 L5.2,4.1 L5.2,4 C5.2,1.8 7,0 9.2,0 Z M5.2,5.3 L2.3,5.3 L2.3,19.3 L5.2,19.3 L5.2,14.8 C5.2,14.5 5.5,14.2 5.8,14.2 L12.2,14.2 C12.5,14.2 12.8,14.5 12.8,14.8 L12.8,19.3 L15.7,19.3 L15.7,5.3 L12.8,5.3 C12.3,6.9 10.8,8.1 9,8.1 C7.2,8.1 5.7,6.9 5.2,5.3 Z M8.6,15.3 L6.4,15.3 L6.4,19.2 L8.6,19.2 L8.6,15.3 Z M11.9,15.3 L9.7,15.3 L9.7,19.2 L11.9,19.2 L11.9,15.3 Z M9.1,1.1 C7.5,1.1 6.2,2.4 6.2,4 C6.2,5.6 7.5,6.9 9.1,6.9 C10.7,6.9 12,5.6 12,4 C12,2.4 10.7,1.1 9.1,1.1 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,0 C10.8,0 11.1,0.3 11.1,0.6 L11.1,3.3 C11.1,3.6 10.8,3.9 10.5,3.9 L0.6,3.9 C0.3,3.9 0,3.6 0,3.3 L0,0.6 C0,0.3 0.3,0 0.6,0 Z M6.7,1.2 L4.4,1.2 L4.4,2.8 L6.7,2.8 L6.7,1.2 Z M9.9,1.2 L7.8,1.2 L7.8,2.8 L9.9,2.8 L9.9,1.2 Z M3.2,1.2 L1.1,1.2 L1.1,2.8 L3.2,2.8 L3.2,1.2 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.2,0 C2.5,0 2.8,0.3 2.8,0.6 L2.8,1.6 L3.8,1.6 C4.1,1.6 4.4,1.9 4.4,2.2 C4.4,2.5 4.1,2.8 3.8,2.8 L2.8,2.8 L2.8,3.8 C2.8,4.1 2.5,4.4 2.2,4.4 C1.9,4.4 1.6,4.1 1.6,3.8 L1.6,2.8 L0.6,2.8 C0.3,2.8 0,2.6 0,2.2 C0,1.9 0.3,1.6 0.6,1.6 L1.6,1.6 L1.6,0.6 C1.6,0.3 1.9,0 2.2,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-586.0 -424.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(585.9999999999995 424.0000000000007)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 18.3,0 18.3,20.4 0,20.4 0,0",
    stroke: "none",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.6000000000000796 8.900000000000034)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 11.1,0 11.1,3.9 0,3.9 0,0",
    stroke: "none",
    fill: "#000000"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.000000000000057 1.8000000000000114)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 4.4,0 4.4,4.4 0,4.4 0,0",
    stroke: "none",
    fill: "#000000"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysicianGroupIcon);
export default __webpack_public_path__ + "static/media/physician_group_icon.821fc68f85d23495493b8be0db368101.svg";
export { ForwardRef as ReactComponent };